module.exports = __webpack_public_path__ + "img/33b17e4a7a302c9c477fbd32db13f9e5.png";